/* Wraps the first alphabet letter of every word in `text-gradient-blue` so it
 * picks up the GJ cyan→royal gradient. Skips non-letter "words" like "&" or
 * punctuation. The split regex captures `\b[a-zA-Z]`, `\b` is zero-width so
 * the captured letter IS the word's first character.
 *
 * Used wherever the GJ first-letter-gradient treatment is wanted on a heading.
 * Pass a plain string child only. */
export function HighlightFirstLetters({children}: {children: string}) {
    return (
        <>
            {children
                .split(/(\b[a-zA-Z])/)
                .map((part, idx) =>
                    /^[a-zA-Z]$/.test(part) ? (
                        <span
                            key={idx}
                            className="text-gradient-blue"
                        >
                            {part}
                        </span>
                    ) : (
                        part
                    ),
                )}
        </>
    );
}
